export default __webpack_public_path__ + "eee45368ac598a6f8526f4aecc8e0417.png";